import React from 'react';
import { connect } from 'react-redux';

import { setQueryString } from '../../actions';


class CaptureQueryString extends React.Component {
  componentDidMount() {
    if (window.location.search) {
      this.props.setQueryString(window.location.search);
    }
  }
  render() {
    return null;
  }
}


const mapDispatchToProps = {
  setQueryString,
};


export default connect(null, mapDispatchToProps)(CaptureQueryString);



// WEBPACK FOOTER //
// ./src/components/CaptureQueryString/index.js